
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-chatbot",
      function () {
        return require("private-next-pages/ai-chatbot.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-chatbot"])
      });
    }
  